/* Hello Gutty — theme.js */
(function () {
  'use strict';

  /* ── Utility ── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* ── Sticky header ── */
  (function initStickyHeader() {
    var header = qs('.site-header');
    if (!header) return;
    var sentinel = 50;
    function onScroll() {
      header.classList.toggle('scrolled', window.scrollY > sentinel);
    }
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ── Hamburger / mobile nav ── */
  (function initMobileNav() {
    var btn = qs('#hamburger-btn');
    var nav = qs('#mobile-nav');
    if (!btn || !nav) return;

    function toggle(open) {
      btn.setAttribute('aria-expanded', open);
      nav.setAttribute('aria-hidden', !open);
      nav.classList.toggle('open', open);
    }

    on(btn, 'click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      toggle(!isOpen);
    });

    // Close on mobile nav link click
    qsa('.mobile-nav__link, .mobile-nav__cta', nav).forEach(function (link) {
      on(link, 'click', function () { toggle(false); });
    });

    // Close on outside click
    on(document, 'click', function (e) {
      if (!btn.contains(e.target) && !nav.contains(e.target)) {
        toggle(false);
      }
    });
  })();

  /* ── Smooth scroll for anchor links ── */
  (function initSmoothScroll() {
    on(document, 'click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var offset = 80; // header height
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  })();

  /* ── FAQ accordion ── */
  (function initFaq() {
    qsa('.faq-item__trigger').forEach(function (trigger) {
      on(trigger, 'click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var answerId = trigger.getAttribute('aria-controls');
        var answer = document.getElementById(answerId);
        if (!answer) return;

        trigger.setAttribute('aria-expanded', !expanded);
        if (expanded) {
          answer.hidden = true;
        } else {
          answer.hidden = false;
          // Animate max-height
          answer.style.maxHeight = answer.scrollHeight + 'px';
          answer.addEventListener('transitionend', function handler() {
            answer.style.maxHeight = '';
            answer.removeEventListener('transitionend', handler);
          });
        }
      });

      // Keyboard support
      on(trigger, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    });
  })();

  /* ── App feature tabs ── */
  (function initTabs() {
    var tabs = qsa('.app-tab');
    var panels = qsa('.phone-panel');
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (t, i) {
        t.classList.toggle('app-tab--active', i === index);
        t.setAttribute('aria-selected', i === index);
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('phone-panel--active', i === index);
      });
    }

    tabs.forEach(function (tab, i) {
      on(tab, 'click', function () { activate(i); });
      on(tab, 'keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          activate((i + 1) % tabs.length);
          tabs[(i + 1) % tabs.length].focus();
        }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = (i - 1 + tabs.length) % tabs.length;
          activate(prev);
          tabs[prev].focus();
        }
      });
    });
  })();

  /* ── Sticky mobile CTA ── */
  (function initStickyCta() {
    var cta = qs('#sticky-mobile-cta');
    if (!cta) return;
    var heroBottom = 0;

    function updateHeroBottom() {
      var hero = qs('.hero');
      if (hero) heroBottom = hero.getBoundingClientRect().bottom + window.scrollY;
    }

    updateHeroBottom();
    on(window, 'resize', updateHeroBottom, { passive: true });

    on(window, 'scroll', function () {
      var scrolled = window.scrollY > heroBottom - 100;
      cta.classList.toggle('visible', scrolled);
      cta.setAttribute('aria-hidden', !scrolled);
    }, { passive: true });
  })();

  /* ── Intersection observer animations ── */
  (function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var style = document.createElement('style');
    style.textContent = [
      '.reveal { opacity: 0; transform: translateY(20px); transition: opacity 0.55s ease, transform 0.55s ease; }',
      '.reveal.visible { opacity: 1; transform: none; }',
    ].join('');
    document.head.appendChild(style);

    var selectors = [
      '.step-card', '.benefit-card', '.review-card',
      '.persona-card', '.faq-item', '.problem__item'
    ];
    var els = qsa(selectors.join(','));
    els.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 4) * 80 + 'ms';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  })();

})();
